<template>
	<div class="row m-0">
	<div class="col-12" :class="$route.path === '/bank-login'? 'p-0': ''">
		<input
			type="date"
			:class="(showSignUpError && this.account.dob === '')?'is-invalid':''"
			class="form-control login-signup-input mt-2 dateInputExcludeDefaultSetting"
			name="Date of Birth"
			placeholder="Date of Birth (dd/mm/YYYY)"
			id="signup-date-of-birth"
			v-model="inputDateOfBirth"
			autocomplete="off"
			data-ismobileonly="false"
			data-test="signUpFormDOBInput"
			@change="dateDisplay()"
		>
		<div
			class="invalid-feedback"
			v-if="showSignUpError"
			v-show="this.account.dob === ''"
			id="signup-dob-error"
			data-test="signUpFormDOBInputError"
		>
			Please Enter Your Date of Birth
		</div>
	</div>
	<div class="col-12" :class="$route.path === '/bank-login'? 'p-0': ''">
		<select
			class="form-control login-signup-input mt-2 border-radius-3"
			id="signup-annual-income-select"
			name="Annual Income"
			v-model="account.income_slab"
			v-validate="'required'"
			:class="(showSignUpError &&
              account.income_slab === 'Choose Your Income Range')?'is-invalid':''"
			data-test="signUpFormAISelect"
			@change="emitVendorPromotionSignupData()"
		>
			<option disabled selected
											data-test="vendorSignUpGstInSelectOption"
											value="Choose Your Income Range"
											id="vendorSignUpGstInSelectOption">
				Choose Your Income Range
			</option>
			<option v-for="(income, index) in getTenantConfig.income_slab" :key="index" :value="income">
				{{income.min}}{{income.suffix}} - {{income.max}}{{income.suffix}}
			</option>
		</select>
		<div
			class="invalid-feedback"
			v-if="showSignUpError"
			v-show="this.account.income_slab === 'Choose Your Income Range'"
			id="signup-ai-error"
			data-test="signUpFormAIInputError"
		>
			Please Choose Your Income Range
		</div>
	</div>
	<div class="col-12" :class="$route.path === '/bank-login'? 'p-0': ''">
		<select
			class="form-control login-signup-input mt-2 border-radius-3"
			id="signup-occupation-select"
			name="Occupation"
			v-model="account.occupation"
			v-validate="'required'"
			:class="(showSignUpError &&
              this.account.occupation === 'Choose Your Occupation')?'is-invalid':''"
			data-test="signUpFormAISelect"
			@change="emitVendorPromotionSignupData()"
		>
			<option disabled selected
											data-test="vendorSignUpGstInSelectOption"
											value="Choose Your Occupation"
											id="vendorSignUpOccupationSelectOptionDefault">
				Choose Your Occupation
			</option>
			<option v-for="(occupation, index) in getTenantConfig.occupations" :key="index">
				{{occupation}}
			</option>
		</select>
		<div
			class="invalid-feedback"
			v-if="showSignUpError"
			v-show="this.account.occupation === 'Choose Your Occupation'"
			id="signup-occupation-error"
			data-test="signUpFormOccupationInputError"
		>
			Please Choose Your Occupation
		</div>
	</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'signup-vendor-promotion-form',
	computed: {
		...mapGetters('siteData', ['getTenantConfig'])
	},
	data () {
		return {
			accountData: {},
			inputDateOfBirth: '',
			tenantConfig: {
				'income_slab': [
					{
						'min': 0,
						'max': 10,
						'suffix': 'L'
					},
					{
						'min': 10,
						'max': 20,
						'suffix': 'L'
					}
				],
				'occupations': [
					'Doctor',
					'Engineer'
				]
			}
		}
	},
	mounted () {
		this.accountData = this.account
	},
	methods: {
		dateDisplay () {
			const convertedDate = this.inputDateOfBirth.split('-')
			convertedDate[1] = convertedDate[1] - 1 // Date.UTC expects a value from 0-11

			const date = new Date(Date.UTC(...convertedDate))
			this.account.dob = date
			this.emitVendorPromotionSignupData()
		},
		emitVendorPromotionSignupData () {
			this.$emit('updateVendorPromotionSignupData', this.accountData)
		}
	},
	props: {
		showSignUpError: {
			type: Boolean,
			default: false
		},
		account: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		account () {
			this.accountData = this.account
		}
	}
}
</script>

<style scoped lang="scss">
	.border-radius-3 {
		border-radius: 3px !important;
	}
	input::-webkit-inner-spin-button, input::-webkit-clear-button {
		display: none !important;
	}
	/*.datetime-reset-button {*/
		/*display: none !important;*/
	/*}*/
</style>
